import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import Comentarios from '../components/Comentarios';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <>
      <Hero />
      <Stats />
      <Services />
      <WhyUs />
      <Comentarios />
      <CTA />
    </>
  );
};

export default Home;
